export default "__VITE_ASSET__ChoUuLNe__"